import React from 'react'
import NotFound from '../shared/NotFound'
import * as sections from './sections/index'

const SectionResolver = props => {
  const { section, ...rest } = props
  const Section = sections[section] || NotFound

  return (
    <Section key={`section-${section}`}
      section={section}
      {...rest}
    />
  )
}

export default SectionResolver